import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import PdfPreview from "../../../components/pdf-preview/PdfPreview";
import { StoreContext } from "../../../store/StoreContext";

const Catalogs = () => {
  const { pdfForPreview } = useContext(StoreContext);

  return (
    <Row className={!pdfForPreview ? "d-none" : ""}>
      <Col col={12}>
        <PdfPreview pdf={pdfForPreview?.items?.url} />
      </Col>
    </Row>
  );
};

export default Catalogs;
